import { useApi } from '../../../../utils/hooks';
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'
import _ from 'lodash';
import useLastItemIsVisible from './hooks/useLastItemIsVisible'
import { useEffect } from 'react';
import Timeline from './Timeline';
import Loading from './Loading';

const queryKey = 'patient-medical-documents';

const MedicalDocumentsHistory = ({ patient }) => {
  const api = useApi();
  const queryClient = useQueryClient();
    
  const fetchMedicalDocuments = ({ pageParam: page }) =>
    api.medicalDocuments({ filters: { patient: { id: patient.id } }, limit: 10, page, sortBy: "date:DESC" })

  const infiniteQuery = useInfiniteQuery({
    queryKey: [queryKey, patient],
    queryFn: fetchMedicalDocuments,
    initialPageParam: 0,
    getNextPageParam: ({ meta: { currentPage, totalPages } }, pages) => currentPage < totalPages ? currentPage : undefined,
  });

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
  } = infiniteQuery;

  const medicalDocuments = _.flatMap(data?.pages, 'data');
  const { itemsContainerRef, lastItemIsVisible } = useLastItemIsVisible(medicalDocuments, isFetching);

  useEffect(() => {
    if (lastItemIsVisible && hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [lastItemIsVisible, hasNextPage, isFetching, fetchNextPage]);

  useEffect(() => {
    return () => {
      queryClient.removeQueries([queryKey, patient]);
    };
  }, [queryClient, patient]);

  return (
    <>
      <Timeline containerRef={itemsContainerRef} medicalDocuments={medicalDocuments} />
      <Loading isLoading={isFetching} />
    </>
  );
};

export default MedicalDocumentsHistory;